import { render, staticRenderFns } from "./HorizontalScroll.vue?vue&type=template&id=ed735d8c&scoped=true"
import script from "./HorizontalScroll.vue?vue&type=script&lang=js"
export * from "./HorizontalScroll.vue?vue&type=script&lang=js"
import style0 from "./HorizontalScroll.vue?vue&type=style&index=0&id=ed735d8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed735d8c",
  null
  
)

export default component.exports